import type { SchemaFeature } from './features.js';
import type { EditorPluginName } from './plugin-names.js';

export const pluginsToFeatures = (plugins: EditorPluginName[]): SchemaFeature[] => {
  return [...new Set(plugins.flatMap(p => pluginToFeatureMap[p]))];
};

const pluginToFeatureMap: { [key in EditorPluginName]: SchemaFeature[] } = {
  actionButton: ['BUTTON'],
  audio: ['AUDIO'],
  codeBlock: ['CODE_BLOCK'],
  collapsibleList: ['COLLAPSIBLE_LIST'],
  divider: ['DIVIDER'],
  file: ['FILE'],
  gallery: ['GALLERY'],
  giphy: ['GIF'],
  hashtag: [],
  html: ['HTML'],
  image: ['IMAGE'],
  link: ['LINK'],
  linkButton: ['BUTTON'],
  linkPreview: ['LINK_PREVIEW', 'EMBED'],
  mentions: ['MENTION'],
  poll: ['POLL'],
  spoiler: ['SPOILER'],
  table: ['TABLE'],
  textColor: ['COLOR_DECORATION'],
  textHighlight: ['COLOR_DECORATION'],
  verticalEmbed: ['APP_EMBED'],
  video: ['VIDEO'],
  ai: [],
  inlineAi: [],
  layout: [],
  emoji: [],
  heading: [],
  indent: [],
  lineSpacing: ['LINE_SPACING'],
};
